import { provision } from '@wix/ambassador-funnel-intro-v1-meta-site-provision-descriptor/http'
import { ProvisionRequest } from '@wix/ambassador-funnel-intro-v1-meta-site-provision-descriptor/types'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'

export const provisionMetasite = async (params: ProvisionRequest) => {
  const request = () => ambassadorHttpClient.request(provision(params))
  return withMonitoring(request, 'provisionMetasite')
}
